import { useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import { useLayoutEffectWithoutSSRComplaining } from '@wix/da-hooks/pkg/useLayoutEffectWithoutSSRComplaining';
const THROTTLE_MS = 200;
export function useScrollRestore(isPageOpen) {
    const [scrollPos, setScrollPos] = useState(typeof window !== 'undefined' ? window.scrollY : 0);
    // Track wasOpen so we can avoid scrolling on pageload
    const wasOpen = useRef(false);
    useEffect(()=>{
        if (isPageOpen) {
            wasOpen.current = true;
        }
    }, [
        isPageOpen
    ]);
    // Track the window scroll and store it locally
    useEffect(()=>{
        if (window) {
            const handleScroll = throttle(()=>{
                requestAnimationFrame(()=>{
                    if (!isPageOpen) {
                        setScrollPos(window.scrollY);
                    }
                });
            }, THROTTLE_MS);
            window.addEventListener('scroll', handleScroll);
            return ()=>window.removeEventListener('scroll', handleScroll);
        }
    }, [
        scrollPos,
        isPageOpen
    ]);
    // After rendering scroll to the last known position
    useLayoutEffectWithoutSSRComplaining(()=>{
        if (wasOpen.current && !isPageOpen && scrollPos) {
            window.scrollTo({
                top: scrollPos
            });
        }
    }, [
        isPageOpen
    ]);
}
